import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="page-container privacy-policy">
      <h1>Gizlilik Politikası</h1>
      <p><strong>Son Güncelleme:</strong> 4 Kasım 2025</p>

      <p>
        Bu gizlilik politikası, VitaLoop ("Uygulama") mobil uygulamasının kullanıcı verilerini nasıl topladığını, kullandığını ve koruduğunu açıklamaktadır. Uygulamayı kullanarak bu politikayı kabul etmiş sayılırsınız.
      </p>

      <h2>Toplanan Veriler</h2>
      <p>
        Uygulamamız, hizmetlerimizi sunmak ve iyileştirmek için aşağıdaki türde verileri toplayabilir:
      </p>
      <ul>
        <li><strong>Kişisel Bilgiler:</strong> Kayıt sırasında sağladığınız ad, e-posta adresi gibi bilgiler (isteğe bağlı).</li>
        <li><strong>Sağlık ve Fitness Verileri:</strong> Kilo, boy, yaş, kalori hedefleri, tüketilen gıdalar ve yapılan egzersizler gibi sizin tarafınızdan girilen veriler.</li>
        <li><strong>Kullanım Verileri:</strong> Uygulama içindeki etkileşimleriniz, en çok kullandığınız özellikler gibi anonimleştirilmiş veriler.</li>
      </ul>

      <h2>Verilerin Kullanımı</h2>
      <p>Toplanan veriler aşağıdaki amaçlarla kullanılır:</p>
      <ul>
        <li>Uygulamanın temel işlevlerini (kalori takibi, raporlama vb.) sağlamak.</li>
        <li>Kullanıcı deneyimini kişiselleştirmek ve size özel öneriler sunmak.</li>
        <li>Uygulama performansını analiz etmek ve hizmetlerimizi iyileştirmek.</li>
        <li>Teknik destek sağlamak ve sorularınızı yanıtlamak.</li>
      </ul>

      <h2>Veri Paylaşımı</h2>
      <p>
        Kişisel bilgileriniz ve sağlık verileriniz, sizin açık rızanız olmadan hiçbir şekilde üçüncü taraf şirket veya kişilerle pazarlama amacıyla paylaşılmaz. Veriler, yalnızca yasal bir zorunluluk durumunda yetkili makamlarla paylaşılabilir.
      </p>

      <h2>Veri Güvenliği</h2>
      <p>
        Verilerinizin güvenliğini sağlamak için endüstri standardı şifreleme ve güvenlik önlemleri kullanıyoruz. Ancak internet üzerinden hiçbir veri aktarım yönteminin %100 güvenli olmadığını unutmamanız önemlidir.
      </p>

      <h2>İletişim</h2>
      <p>
        Gizlilik politikamızla ilgili herhangi bir sorunuz veya endişeniz varsa, lütfen bizimle <a href="mailto:destek@vitaloop.com">destek@vitaloop.com</a> adresi üzerinden iletişime geçin.
      </p>
    </div>
  );
}

export default PrivacyPolicy;
